import { useCurrentEditor } from "@tiptap/react";
import { BubbleMenu } from "@tiptap/react/menus";
import { useRef } from "react";

import { EditorButtonGroup } from "./editor-button-groups";
import { EditorButtonGroupTextMarks } from "./editor-button-groups/editor-button-group-text-marks";
import { EditorButtonBlockquote } from "./editor-buttons/editor-button-blockquote";
import { EditorButtonCode } from "./editor-buttons/editor-button-code";
import { EditorButtonCodeBlock } from "./editor-buttons/editor-button-code-block";
import { EditorButtonLink } from "./editor-buttons/editor-button-link";
import { EditorDropdownMenuTextBlockFormat } from "./editor-dropdown-menu-text-block-format";
import { EditorToolbar } from "./editor-toolbar";
import { EditorToolbarSeparator } from "./editor-toolbar-separator";

export const EditorBubbleMenu = () => {
  const menuRef = useRef<HTMLDivElement>(null);
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  return (
    <BubbleMenu editor={editor} className="bg-card border border-border rounded-md p-1 shadow-lg">
      {/* NOTE: We need to use a div to wrap the editor toolbar and use a ref to ensure any dropdown menus are properly
      positioned with respect to the container ref when the component is mounted or refreshed. */}
      <div ref={menuRef}>
        <EditorToolbar className="py-0">
          <EditorDropdownMenuTextBlockFormat containerRef={menuRef} />

          <EditorToolbarSeparator />

          <EditorButtonGroupTextMarks />

          <EditorToolbarSeparator />

          <EditorButtonLink containerRef={menuRef} />

          <EditorToolbarSeparator />

          <EditorButtonGroup>
            <EditorButtonBlockquote />
            <EditorButtonCode />
            <EditorButtonCodeBlock />
          </EditorButtonGroup>
        </EditorToolbar>
      </div>
    </BubbleMenu>
  );
};
